import queryString from 'querystring';
import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";

let redux = reduxCreator.type('TAG_MODERATIONS_VERIFICATION_MEDIAS').plugin(axiosPlugin, {template: "array"});
let fetchAction = redux.fetchActionGet();


export const TYPES = redux.types;

export const fetchVerificationMedias = (query, more = false) => fetchAction(`/tag-moderations/verifications/?${queryString.stringify(query)}`,null,{more});
export const resetVerificationMedias = () => redux.actions.reset();

export const verificationMedias = redux.reducer();